import styled from "styled-components";

import type { ToolbarProps } from "./Toolbar";

export const StyledToolbar = styled.div<Partial<ToolbarProps>>`
  box-sizing: border-box;
  background-color: var(--page-paper-main);
  background-image: linear-gradient(
    var(--color-primary-300),
    var(--color-primary-300)
  );
  border-radius: 8px;
  border: 1px solid var(--color-primary);
  box-shadow: 0px 64px 64px rgba(0, 0, 0, 0.06),
    0px 32px 32px rgba(0, 0, 0, 0.03), 0px 16px 16px rgba(0, 0, 0, 0.02),
    0px 4px 4px rgba(0, 0, 0, 0.02), 0px 2px 2px rgba(0, 0, 0, 0.02);
  bottom: 24px;
  display: flex;
  left: calc(50% + var(--toolbar-inline-offset, 0px));
  padding: 12px 16px;
  position: fixed;
  transform: translateX(-50%);
  width: 100%;
  max-width: 800px;
`;
